import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Gates a subtree of routes to a single partner tier.
 *
 * Mirrors the backend's tier gating (API docs §"Authentication": chain-only
 * routes like /branches and branch-only routes like /employees return 403
 * for the wrong tier) so the UI never lets a partner navigate somewhere
 * they'd immediately get a 403 from — instead they're bounced to the
 * dashboard before a request is even made.
 *
 * Usage: <Route element={<KindRoute allow="CHAIN" />}> ... </Route>
 */
export default function KindRoute({ allow }) {
  const { partner, loading } = useAuth();

  if (loading) return null; // ProtectedRoute above already renders the loader

  if (partner?.kind !== allow) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
